import { initVehicleSelectWidget } from './utils/fn';

export function makeModelFilter() {
  const widgets = document.querySelectorAll('.make-model-filter_wrapper:not(.initialized)');

  widgets.forEach((widget) => {
    const parentVehicleWidget = widget.closest('.make-model-filter_wrapper');
    const form = widget.querySelector('form');
    const type = widget.dataset.type
    const patternUrl = form.getAttribute('action');
    const dataCategory = widget.querySelector('.cars-form-make-js')?.getAttribute('data-category');
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      const formData = new FormData(form);
      const values = Array.from(formData.entries()).map(([_, value]) => value.trim()).filter(Boolean);
      let url;
      if (dataCategory) {
        url = `${patternUrl}category/${dataCategory}/?make_alias=${values[0]}`;
        if (values[1]) {
          url += `&submodel_alias=${values[1]}`;
        }
      } else {
        url = `/${values.join('/')}${patternUrl}`;
      }
      window.location.href = url;
    });

    if(!parentVehicleWidget.classList.contains('initialized')) {
      initVehicleSelectWidget(widget, i18n, parentVehicleWidget.classList.contains('initialized'), {
        with_content: type
      } );
    };

    parentVehicleWidget.classList.add('initialized');
  });
}